import React from "react";

export default function Section({ id, eyebrow, title, subtitle, children, className = "", center = false, bg = "white" }) {
  const bgClass = bg === "light" ? "bg-[#E8F0FB]" : bg === "primary" ? "hc-banner-gradient text-white" : "bg-white";
  return (
    <section id={id} className={`${bgClass} ${className}`}>
      <div className="hc-container py-14 md:py-20">
        {(eyebrow || title || subtitle) && (
          <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""} mb-10`}>
            {eyebrow && (
              <div className={`hc-chip mb-3 ${bg === "primary" ? "!bg-white/20 !text-white !border-white/30" : ""}`}>{eyebrow}</div>
            )}
            {title && (
              <h2 className={`text-3xl md:text-4xl font-extrabold leading-tight ${bg === "primary" ? "text-white" : "text-[#0F2A4A]"}`}>{title}</h2>
            )}
            {subtitle && (
              <p className={`mt-3 text-base md:text-lg leading-relaxed ${bg === "primary" ? "text-white/90" : "text-slate-600"}`}>{subtitle}</p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
